import router from "@router/index";
import crypto from "@utils/crypto";
import $api from "@services/Api";
import Settings from "../../settings.json";
import { Login as EmployeeLogin } from "@request/Employee";

const STORAGE_USER = "employee_user";
const STORAGE_EAT = "employee_eat";

const state = {
  session: null,
};

const getters = {
  getEmployeeSession: (s) => s.session,
  getEmployeeUser: (s) => s.session?.data || {},
  getEmployeeId: (s) => {
    const d = s.session?.data?.employeeInfo || {};
    const id = d.id ?? d.employeeId ?? d.userId;
    if (id == null || id === "") return "";
    return String(id);
  },
  /** Çalışan bölgesi — müşteri listesi `regionId` filtresi için */
  getEmployeeRegionId: (s) => {
    const root = s.session?.data || {};
    const emp =
      root.employeeInfo && typeof root.employeeInfo === "object"
        ? root.employeeInfo
        : {};
    const rid =
      emp.regionId ?? root.regionId ?? emp.region?.id ?? root.region?.id;
    if (rid == null || rid === "") return "";
    return String(rid);
  },
};

const mutations = {
  SET_SESSION(state, payload) {
    state.session = payload;
    const token = payload?.data?.token;
    if (token) $api.token = token;
  },
  CLEAR_SESSION(state) {
    state.session = null;
  },
};

const actions = {
  signOutSilent({ commit }) {
    localStorage.removeItem(STORAGE_USER);
    localStorage.removeItem(STORAGE_EAT);
    commit("CLEAR_SESSION");
  },
  async signIn({ commit }, form) {
    const response = await EmployeeLogin(form);
    if (response.message !== "OK") return response;
    const token = response.data?.token ?? response.token;
    if (!token) return response;

    const data = {
      ...(typeof response.data === "object" && response.data
        ? response.data
        : {}),
      token,
    };
    const payload = { ...response, data };
    commit("SET_SESSION", payload);
    localStorage.setItem(STORAGE_USER, crypto.crypto(JSON.stringify(payload)));
    const eat = new Date().getTime() + Settings.tokenTime * 24 * 60 * 60 * 1000;
    localStorage.setItem(STORAGE_EAT, crypto.crypto(String(eat)));
    setTimeout(() => {
      router.replace({ name: "employee-app-home" });
    }, 300);
    return response;
  },
  signOut({ commit, dispatch }, { message, variant } = {}) {
    dispatch("signOutSilent");
    $api.token = "";
    if (message) {
      commit(
        "SET_AUTH_MESSAGE",
        { status: true, message, variant: variant || "success" },
        { root: true }
      );
    }
    const route = router.app && router.app.$route;
    if (route && route.name !== "employee-app-login") {
      router.replace({ name: "employee-app-login" });
    }
  },
  restoreFromStorage({ commit, dispatch }) {
    try {
      const raw = localStorage.getItem(STORAGE_USER);
      if (!raw) {
        dispatch("signOutSilent");
        return false;
      }
      const parsed = JSON.parse(crypto.decrypto(raw));
      if (!parsed?.data?.token) {
        dispatch("signOutSilent");
        return false;
      }
      commit("SET_SESSION", parsed);
      $api.token = parsed.data.token;
      return true;
    } catch {
      dispatch("signOutSilent");
      return false;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
